<template>
    <div>
        <div class="card_row">
            <Card class="card" @submitted="saveModel">
                <template #title>
                    Налаштування сервісу Прайс-лист зовнішній
                </template>

                <template #content v-if="settingsClientData">

                    <!-- Name -->
                    <div class="field">
                        <label for="is_promo_view">
                            <Checkbox v-model="settingsClientData.is_promo_view" :binary="true" />
                            <b>Лейба “Акція” відображати на клієнтській стороні</b>
                        </label>
                        <label for="is_new_view">
                            <Checkbox v-model="settingsClientData.is_new_view" :binary="true" />
                            <b>Лейба “Новинка” відображати на клієнтській стороні</b>
                        </label>
                        <label for="is_hit_view">
                            <Checkbox v-model="settingsClientData.is_hit_view" :binary="true" />
                            <b>Лейба “Хіт” відображати на клієнтській стороні</b>
                        </label>
                        <label for="description_view">
                            <Checkbox v-model="settingsClientData.description_view" :binary="true" />
                            <b>Вкладка “Опис” відображати на клієнтській стороні</b>
                        </label>
                        <label for="characteristics_view">
                            <Checkbox v-model="settingsClientData.characteristics_view" :binary="true" />
                            <b>Вкладка “Характеристики” відображати на клієнтській стороні</b>
                        </label>
                        <label for="accessories_view">
                            <Checkbox v-model="settingsClientData.accessories_view" :binary="true" />
                            <b>Вкладка “Аксесуари” відображати на клієнтській стороні</b>
                        </label>
                        <label for="analogs_view">
                            <Checkbox v-model="settingsClientData.analogs_view" :binary="true" />
                            <b>Вкладка “Аналоги” відображати на клієнтській стороні</b>
                        </label>
                        <label for="buy_with_product_view">
                            <Checkbox v-model="settingsClientData.buy_with_product_view" :binary="true" />
                            <b>Вкладка “З цим товаром купують” відображати на клієнтській стороні</b>
                        </label>
                        <label for="documentation_view">
                            <Checkbox v-model="settingsClientData.documentation_view" :binary="true" />
                            <b>Вкладка “Документація” відображати на клієнтській стороні</b>
                        </label>
                        <label for="custom_brand_view">
                            <Checkbox v-model="settingsClientData.custom_brand_view" :binary="true" />
                            <b>Відображати бренд Schneider Electric</b>
                        </label>
                        <label for="custom_brand_view">
                            <Checkbox v-model="settingsClientData.brand_view" :binary="true" />
                            <b>Відображення Бренду як властивості із 1C</b>
                        </label>
                        <label for="custom_decision_vies">
                            <Checkbox v-model="settingsClientData.decision_view" :binary="true" />
                            <b>Відображення рішень</b>
                        </label>
                    </div>
                </template>
            </Card>
            <Card class="card" @submitted="saveModel">
                <template #title>
                    Налаштування сервісу Прайс-лист внутрішній
                </template>

                <template #content v-if="settingsData">

                    <!-- Name -->
                    <div class="field">
                        <label for="is_promo_view">
                            <Checkbox v-model="settingsData.is_promo_view" :binary="true" />
                            <b>Лейба “Акція” відображати на клієнтській стороні</b>
                        </label>
                        <label for="is_new_view">
                            <Checkbox v-model="settingsData.is_new_view" :binary="true" />
                            <b>Лейба “Новинка” відображати на клієнтській стороні</b>
                        </label>
                        <label for="is_hit_view">
                            <Checkbox v-model="settingsData.is_hit_view" :binary="true" />
                            <b>Лейба “Хіт” відображати на клієнтській стороні</b>
                        </label>
                        <label for="description_view">
                            <Checkbox v-model="settingsData.description_view" :binary="true" />
                            <b>Вкладка “Опис” відображати на клієнтській стороні</b>
                        </label>
                        <label for="characteristics_view">
                            <Checkbox v-model="settingsData.characteristics_view" :binary="true" />
                            <b>Вкладка “Характеристики” відображати на клієнтській стороні</b>
                        </label>
                        <label for="accessories_view">
                            <Checkbox v-model="settingsData.accessories_view" :binary="true" />
                            <b>Вкладка “Аксесуари” відображати на клієнтській стороні</b>
                        </label>
                        <label for="analogs_view">
                            <Checkbox v-model="settingsData.analogs_view" :binary="true" />
                            <b>Вкладка “Аналоги” відображати на клієнтській стороні</b>
                        </label>
                        <label for="buy_with_product_view">
                            <Checkbox v-model="settingsData.buy_with_product_view" :binary="true" />
                            <b>Вкладка “З цим товаром купують” відображати на клієнтській стороні</b>
                        </label>
                        <label for="documentation_view">
                            <Checkbox v-model="settingsData.documentation_view" :binary="true" />
                            <b>Вкладка “Документація” відображати на клієнтській стороні</b>
                        </label>
                        <label for="custom_brand_view">
                            <Checkbox v-model="settingsData.custom_brand_view" :binary="true" />
                            <b>Відображати бренд Schneider Electric</b>
                        </label>
                        <label for="custom_brand_view">
                            <Checkbox v-model="settingsData.brand_view" :binary="true" />
                            <b>Відображення Бренду як властивості із 1C</b>
                        </label>
                        <label for="custom_decision_vies">
                            <Checkbox v-model="settingsData.decision_view" :binary="true" />
                            <b>Відображення рішень</b>
                        </label>
                    </div>
                </template>
            </Card>
        </div>
        <div class="card_row_footer">
            <Button
                label="Зберегти"
                @click="saveModel"
            />
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import Card from "primevue/card";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import Toast from 'primevue/toast';
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Card,
        Button,
        Checkbox,
        "p-toast": Toast,
    },
    props: {
        settings: {
            type: Object,
            required: false,
        },
        client_settings: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            settingsClientData: this.client_settings ? _.cloneDeep(this.client_settings) : {
                is_promo_view: false,
                is_new_view: false,
                is_hit_view: false,
                description_view: false,
                characteristics_view: false,
                accessories_view: false,
                analogs_view: false,
                buy_with_product_view: false,
                documentation_view: false,
                custom_brand_view: false,
                brand_view: false,
                decision_view: false,
            },
            settingsData: this.settings ? _.cloneDeep(this.settings) : {
                is_promo_view: false,
                is_new_view: false,
                is_hit_view: false,
                description_view: false,
                characteristics_view: false,
                accessories_view: false,
                analogs_view: false,
                buy_with_product_view: false,
                documentation_view: false,
                custom_brand_view: false,
                brand_view: false,
                decision_view: false,
            }
        }
    },
    methods: {
        saveModel() {
            axios.post(this.route('api.price_list_setting_update'), {settings: this.settingsData, client_settings: this.settingsClientData})
                .then((result) => {
                    this.$toast.add({severity: 'info', summary: 'Збережено', detail: '', life: 3000});
                }).catch((error) => {
                    console.log(error);
                })
        }
    }
}
</script>

<style scoped>
.field label {
    display: flex;
    align-items: center;
    gap: 10px;
}
.card_row {
    display: flex;
    gap: 10px;
}
.card_row .card {
    width: 100%;
}
.card_row_footer {
    display: flex;
    width: 100%;
    justify-content: flex-end;
}
</style>